<template>
  <mdb-btn-group>
    <mdb-btn
      v-for="(ct, i) in cargoTypes"
      :key="i"
      size="sm"
      color="info"
      @click.native="toggleCargoType(ct.name)"
      :active="queryCargoTypes.includes(ct.name)"
      :title="ct.description"
    ><mdb-icon
      v-if="queryCargoTypes.includes(ct.name)"
      icon="check"
      class="mr-2"
    />{{ ct.name }}</mdb-btn>
  </mdb-btn-group>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { mdbBtnGroup, mdbBtn, mdbIcon } from 'mdbvue'

export default {
  name: 'CalcControlsCargoTypesSelect',
  computed: mapState('calc', {
    cargoTypes: state => state.data.cargoTypes,
    queryCargoTypes: state => state.query.cargoTypes
  }),
  methods: {
    ...mapActions('calc', ['toggleCargoType'])
  },
  components: {
    mdbBtnGroup, mdbBtn, mdbIcon
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcControlsCargoTypesSelect.vue